<!-- =========================================================================================
    File Name: TableMiscellaneous.vue
    Description: Combine filter,sorter, pagination etc.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card title="Store List">
    <!-- <p>
      You can add a
      <strong>filtered, sorted, paginated and multi selected</strong> table with combination of the
      <code>search</code>,
      <code>multiple</code> and
      <code>pagination</code> properties for example
    </p>-->
    <!-- <br /> -->
    <vs-button color="primary" type="border" icon="add" to="store/create"
      >Create Store</vs-button
    >
    <br />
    <vs-table v-model="selected" stripe :data="stores" id="button-with-loading">
      <template slot="thead">
        <vs-th>Name</vs-th>
        <vs-th>No. WA</vs-th>
        <vs-th>Photo</vs-th>
        <vs-th>Payment Account</vs-th>
        <vs-th>Address</vs-th>
        <vs-th>Detail Address</vs-th>

        <vs-th sort-key="title">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.name">{{ tr.name }}</vs-td>
          <vs-td :data="tr.no_wa">{{ tr.no_wa }}</vs-td>
          <vs-td :data="tr.name"
            ><img :src="tr.photo" class="rounded" width="50"
          /></vs-td>
          <vs-td
            ><vs-button
              @click="setPopUp(tr.payment_accounts)"
              color="primary"
              icon-pack="feather"
              icon="icon-search"
            ></vs-button
          ></vs-td>
          <vs-td :data="tr.address">{{
            tr.address
              ? tr.address.province_name +
                ", " +
                tr.address.city_name +
                ", " +
                tr.address.district_name
              : ""
          }}</vs-td>
          <vs-td :data="tr.address">{{
            tr.address ? tr.address.detail_address : ""
          }}</vs-td>
          <vs-td>
            <div class="flex">
              <vs-button
                type="border"
                size="small"
                icon-pack="feather"
                icon="icon-edit"
                color="warning"
                class="mr-2"
                @click="editStore(tr.id)"
              >
              </vs-button>
              <vs-button
                type="border"
                size="small"
                icon-pack="feather"
                icon="icon-trash"
                color="danger"
                @click="deleteAlert('danger', tr.id)"
              ></vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <template>
      <div class="demo-alignment">
        <vs-popup title="Payment Account" :active.sync="popupActive">
          <div
            class="vx-col w-full"
            v-for="payment_account in popUpData"
            :key="payment_account.id"
          >
            <div class="vx-row margin-custom">
              <div class="vx-col w-full mb-base md:mt-0">
                <h3 class="text-black">{{ payment_account.bank.name }}</h3>

                <table>
                  <tr>
                    <td>Account Number</td>
                    <td>: {{ payment_account.account_number }}</td>
                  </tr>
                  <tr>
                    <td>Account Name</td>
                    <td>: {{ payment_account.name }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vs-popup>
      </div>
    </template>
    <template>
     <br>
      <vs-pagination :total="20" v-model="page" :max="10"></vs-pagination>
    </template>
  </vx-card>
</template>

<script>
import axios from '../../../axios110'
import Prism from 'vue-prism-component'
import moment from 'moment'
import router from '../../../router'
export default {
  data() {
    return {
      'selected': [],
      'tableList': [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      'stores': [],
      'colorAlert': 'primary',
      'titleAlert': 'Alert',
      'activeAlert': false,
      'valueInput': '',
      'userAuth': this.$store.getters.userAuth,
      'deleteId': null,
      popupActive: false,
      popUpData: [],
      page: 1,
      limit: 10,


    }
  },
  watch: {
    page(newValue, oldValue) {
      this.getStore()

    },


  },
  mounted() {
    this.getStore()

  },
  methods: {
    setPopUp(tr) {

      this.popupActive = true
      this.popUpData = tr

    },

    getStore() {
      //console.log('ini mounted')
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      })
      //axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.getters.tokenAuth
      axios.get('/ecommerce/web/store' + '?limit=' + this.limit + '&page=' + this.page, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
            //   this.errorRecover = true
            //   this.messageRecover = 'Email tidak terdaftar!'
          } else {
            console.log(res)
            this.stores = res.data
          }
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")

        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")
        })

    },

    format_date(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    limitChar(str) {
      var output = ''
      if (str.length > 100) {
        str = str.substring(0, 100)
        output = str + '...'
      } else {
        output = str
      }
      return output
    },
    deleteAlert(color, id) {
      this.colorAlert = color
      this.deleteId = id
      console.log(`masuk delete${this.deleteId}`)
      this.$vs.dialog({
        color: this.colorAlert,
        title: 'Apa anda yakin?',
        text: 'Setelah dihapus data ini tidak bisa diakses lagi',
        accept: this.deleteStore
      })
    },

    deleteStore() {
      console.log(`masuk delete${this.deleteId}`)
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      })
      axios.delete(`/ecommerce/web/store/${this.deleteId}`, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
            //   this.errorRecover = true
            //   this.messageRecover = 'Email tidak terdaftar!'
          } else {
            this.page = 1
            this.getStore()


          }
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")

          this.$vs.notify({
            color: 'success',
            title: 'Berhasil!',
            text: 'Berhasil hapus store account'
          })

        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")
        })


    },
    editStore(id) {
      console.log(id)
      this.$router.push(`/store/edit/${id}`)
    },


  },
  components: {
    Prism
  }
}
</script>
